import React, { Dispatch, SetStateAction } from "react";

import TransferDetails from "fe-shared-transactions/src/components/TransferDetails";

import {
  Company,
  PermissionLevel,
  UserPermission,
} from "fe-shared/src/types/domain";
import { hasPermission } from "fe-shared/src/helpers/permissions";

import { PERMISSIONS } from "consts";

interface Props {
  company: Company;
  setLastOpenedTransfersNumber: Dispatch<SetStateAction<string | null>>;
}

const TransferDetailsView = (props: Props) => {
  const { company, setLastOpenedTransfersNumber } = props;

  const isPermitted = (permission: UserPermission) =>
    hasPermission(company?.permissions, permission);
  const hasSidebar = isPermitted({
    name: PERMISSIONS.transferHistory,
    level: PermissionLevel.Read,
  });

  const canExportHistory = isPermitted({
    name: PERMISSIONS.transferHistoryExport,
    level: PermissionLevel.Full,
  });

  const canViewTransferDetails = isPermitted({
    name: PERMISSIONS.transfersDetails,
    level: PermissionLevel.Read,
  });

  const canEditTransfer = isPermitted({
    name: PERMISSIONS.transfersDetails,
    level: PermissionLevel.Full,
  });

  const canCancelTransfer = isPermitted({
    name: PERMISSIONS.transferCancel,
    level: PermissionLevel.Read,
  });

  return (
    <TransferDetails
      hasSidebar={hasSidebar}
      canEditTransfer={canEditTransfer}
      canExportHistory={canExportHistory}
      canCancelTransfer={canCancelTransfer}
      canViewTransferDetails={canViewTransferDetails}
      setLastOpenedTransfersNumber={setLastOpenedTransfersNumber}
    />
  );
};

export default TransferDetailsView;
